// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M19.9983 2.00293V3.99941H22.0023V5.99941H20.7451C21.2068 7.45561 20.8602 9.11256 19.7054 10.2674L10.2656 19.7072C9.11077 20.862 7.45381 21.2086 5.99761 20.7469L5.99761 22.001H3.99761L3.99761 20.0001H2.00195V18.0001H3.2508C2.78915 16.5439 3.13571 14.887 4.2905 13.7322L13.7304 4.2923C14.8852 3.13751 16.5421 2.79095 17.9983 3.2526V2.00293H19.9983Z"}}]};

const SausageFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'sausage-filled',
    ref,
    icon: element,
  },
));

SausageFilledIcon.displayName = 'SausageFilledIcon';

export default SausageFilledIcon;
